/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Seat_Types_Card_BaseInputs */



/**
* | output |
* | --- |
* | "incl. {count} base" |
*
* @param {Seat_Types_Card_BaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_base = /** @type {((inputs: Seat_Types_Card_BaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_BaseInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`inkl. ${i?.count} Basis`)
	return /** @type {LocalizedString} */ (`incl. ${i?.count} base`)
});